import { rem, Text, TextInput } from '@mantine/core';
import { DateInput, type DateValue } from '@mantine/dates';
import dayjs from 'dayjs';
import { BiSolidDownArrow } from 'react-icons/bi';
import { dateFormatUI, dateFormat } from '@/index';
import { useEmployeeFormContext } from '../NewEmployeePage';

export const IdentityCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const badge = form.values.cards.find(
    (card: { type: string }) => card.type === 'badge'
  );

  function handleDateChange(date: string) {
    const updatedCards = [...form.values.cards];
    const index = form.values.cards.findIndex(
      (card: { type: string }) => card.type === 'badge'
    );

    if (index !== -1) {
      updatedCards[index] = {
        ...updatedCards[index],
        issAt: date,
      };
    } else {
      const newBadge = {
        type: 'badge',
        issAt: date,
        expAt: null,
        deposit: '',
      };
      updatedCards.push(newBadge);
    }
    form.setFieldValue('cards', updatedCards);
  }

  const handleDepositChange = (newDeposit: string) => {
    const index = form.values.cards.findIndex(
      (card: { type: string }) => card.type === 'badge'
    );
    const updatedCards = [...form.values.cards];

    updatedCards[index] = {
      ...updatedCards[index],
      deposit: newDeposit,
    };
    form.setFieldValue('cards', updatedCards);
  };

  const setDate = (date: DateValue) => {
    handleDateChange(dayjs(date).format());
  };

  const setDeposit = (value: React.ChangeEvent<HTMLInputElement>) => {
    handleDepositChange(value.target.value);
  };

  return (
    <div>
      <Text fw={700} size="lg" mt="lg">
        Osobní průkaz
      </Text>

      <DateInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="datum vydání"
        label="Datum vydání"
        rightSection={icon}
        valueFormat={dateFormatUI}
        value={
          badge && dayjs(badge.issAt).isValid()
            ? dayjs(badge.issAt).toDate()
            : undefined
        }
        onChange={setDate}
        locale="cs"
      />
      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="číslo průkazu"
        label="Číslo průkazu"
        disabled={!badge}
        value={badge?.deposit ? badge.deposit : ''}
        onChange={setDeposit}
      />
    </div>
  );
};
